import { Localization } from "../../../common/localizable-component";
import { ListLocalization } from "./list-types";

export const LIST_LOCALIZATION: Localization<ListLocalization> = {
  en: {
    itemsPerPage: "Items per page",
    of: "of",
    items: "items"
  },
  de: {
    itemsPerPage: "Elemente pro Seite",
    of: "von",
    items: "Elementen"
  },
  sv: {
    itemsPerPage: "Träffar per sida",
    of: "av",
    items: "träffar"
  },
  nl: {
    itemsPerPage: "Artikelen per pagina",
    of: "van",
    items: "items"
  },
  it: {
    itemsPerPage: "Elementi per pagina",
    of: "di",
    items: "elementi"
  },
  hu: {
    itemsPerPage: "Tételek oldalanként",
    of: "a",
    items: "Tételek"
  },
  da: {
    itemsPerPage: "Varer per side",
    of: "af",
    items: "varer"
  },
  fr: {
    itemsPerPage: "Éléments par page",
    of: "de",
    items: "éléments"
  },
  es: {
    itemsPerPage: "Artículos por página",
    of: "de",
    items: "elementos"
  },
  pl: {
    itemsPerPage: "Pozycje na stronie",
    of: "z",
    items: "pozycje"
  },
  ro: {
    itemsPerPage: "Elemente per pagină",
    of: "de",
    items: "elemente"
  },
  hr: {
    itemsPerPage: "stavke po stranici",
    of: "od",
    items: "stavke"
  },
  cs: {
    itemsPerPage: "Položky na stránku",
    of: "z",
    items: "položky"
  },
  sl: {
    itemsPerPage: "Elementi na stran",
    of: "na",
    items: "Elementi"
  }
};
